<template>
  <aside class="app-sidebar shadow-lg">
    <!-- منطقة الشعار -->
    <div class="sidebar-brand text-center border-bottom border-secondary pb-3 pt-3">
      <a href="../index.html" class="brand-link text-decoration-none d-flex align-items-center justify-content-center gap-2">
        <img :src="'../assets/img/AdminLTELogo.png'" alt="Logo" class="brand-image rounded-circle shadow-sm" width="35" height="35" />
        <span class="brand-text font-weight-light text-white fs-5">كنترول الاعدادية</span>
      </a>
    </div>

    <!-- منطقة القوائم -->
    <div class="sidebar-wrapper mt-2 custom-scrollbar">
      <nav>
        <ul class="nav nav-pills nav-sidebar flex-column p-2" role="menu">
          
          <li
            v-for="link in visibleLinks"
            :key="link.name"
            class="nav-item mb-1"
            :class="{ 'menu-open': activeSubmenu === link.name }"
          >
            <!-- 1. رابط يحتوي على قائمة فرعية -->
            <template v-if="link.hasChildren && link.visibleChildren && link.visibleChildren.length > 0">
              <a href="#" class="nav-link d-flex align-items-center justify-content-between" 
                 :class="{ 'active': activeSubmenu === link.name }"
                 @click.prevent="toggleSubmenu(link.name)">
                
                <div class="d-flex align-items-center">
                  <i :class="link.icon" class="nav-icon"></i>
                  <span class="nav-text">{{ link.text }}</span>
                </div>
                
                <i class="fas fa-angle-left right-icon transition-icon" 
                   :class="{ 'rotate-down': activeSubmenu === link.name }"></i>
              </a>

              <!-- القائمة الفرعية -->
              <transition name="slide-fade">
                <ul class="nav nav-treeview" v-if="activeSubmenu === link.name">
                  <li v-for="subLink in link.visibleChildren" :key="subLink.name" class="nav-item">
                    
                    <!-- التعديل تم هنا: حذفنا @click.native="hideSubmenu" -->
                    <router-link 
                      :to="{ name: subLink.name }" 
                      class="nav-link sub-link"
                      active-class="active-sub"
                      @click.native="handleLinkClick" 
                    >
                      <i :class="subLink.icon" class="nav-icon sub-icon"></i>
                      <span class="nav-text">{{ subLink.text }}</span>
                    </router-link>

                  </li>
                </ul>
              </transition>
            </template>

            <!-- 2. رابط عادي بدون قائمة فرعية -->
            <template v-else>
              <!-- هنا نبقي على hideSubmenu لإغلاق القوائم الأخرى عند الانتقال لصفحة رئيسية -->
              <router-link 
                :to="{ name: link.name }" 
                class="nav-link d-flex align-items-center"
                active-class="active"
                @click.native="hideSubmenu"
              >
                <i :class="link.icon" class="nav-icon"></i>
                <span class="nav-text">{{ link.text }}</span>
              </router-link>
            </template>
          </li>

        </ul>
      </nav>
    </div>
  </aside>
</template>
<script>
  import { appLinks } from '@/config/menuLinks';
export default {
  name: "Sidebar",
  props: {
    users: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      allLinks: appLinks,
menuSettings: {},   // هنا سنحفظ حالة (true/false)
      activeSubmenu: null,
    };
  },

  watch: {
     $route: {
    immediate: true,
    handler(newRoute) {
      const active = this.allLinks.find(link =>
        link.hasChildren &&
        link.children.some(child => child.name === newRoute.name)
      );

      this.activeSubmenu = active ? active.name : null;
    }
  }
  },
  mounted() {
    // 1. تحميل الإعدادات فور فتح الصفحة
    this.updateMenuState();

    // 2. الاستماع للحدث القادم من صفحة الإعدادات
    window.addEventListener('menu-settings-changed', this.updateMenuState);
  },

  // تنظيف الذاكرة عند الخروج
  beforeDestroy() {
    window.removeEventListener('menu-settings-changed', this.updateMenuState);
  },
  computed: {
    visibleLinks() {
      if (!this.users || !this.users.role) return [];

      return this.allLinks.filter((mainLink) => {
        // 1. شرط الصلاحية (Role)
        const isRoleAllowed = mainLink.roles.includes(this.users.role);
        
        // 2. شرط الإعدادات (Settings)
        // نتحقق من المتغير menuSettings الذي يتم تحديثه تلقائياً
        // إذا لم يكن موجوداً، نعتبره true (ظاهر)
        const isEnabled = this.menuSettings[mainLink.name] !== false;

        // إذا كان له أبناء
        if (mainLink.hasChildren && mainLink.children) {
          mainLink.visibleChildren = mainLink.children.filter((child) => {
             return child.roles.includes(this.users.role) && (this.menuSettings[child.name] !== false);
          });
          // يظهر الأب فقط إذا كان مسموحاً به ومفعلاً ولديه أبناء ظاهرين
          return isRoleAllowed && isEnabled && mainLink.visibleChildren.length > 0;
        }

        // رابط عادي
        return isRoleAllowed && isEnabled;
      });
    }
  },

  methods: {
        updateMenuState() {
      const settingsStr = localStorage.getItem('app_settings');
      if (settingsStr) {
        try {
          const settings = JSON.parse(settingsStr);
          // نحدث المتغير، وبفضل Vue Reactivity، سيعيد computed حساب الروابط فوراً
          this.menuSettings = settings.menu_visibility || {};
        } catch (e) {
          console.error("Error parsing settings");
        }
      }
    },
      handleLinkClick() {
    // 1. إرسال حدث للأب (Layout) ليقوم بإغلاق السايد بار
    // this.$emit('close-sidebar');
    
    // 2. (اختياري) إذا كنت تستخدم jQuery/AdminLTE التقليدي وتتحكم في الكلاسات يدوياً:
    document.body.classList.remove('sidebar-open');
    // document.body.classList.add('sidebar-collapse');
  },
    toggleSubmenu(name) {
      this.activeSubmenu = this.activeSubmenu === name ? null : name;
    },
    hideSubmenu() {
      this.activeSubmenu = null;
    }
  }
};
</script>

<style scoped>
/* 1. الإطار العام للسايدبار */
.app-sidebar {
  position: fixed;
  top: 0;
  right: 0; /* لأننا RTL */
  bottom: 0;
  width: 260px; 
  background-color: #343a40; /* لون غامق كلاسيكي */
  display: flex;
  flex-direction: column;
  z-index: 1038;
  transition: width 0.3s ease-in-out;
  direction: rtl;
}

/* 2. منطقة الشعار */
.sidebar-brand {
  background-color: #343a40;
  padding: 10px;
}
.brand-text {
  font-size: 1.1rem;
  font-weight: bold;
  color: #c2c7d0;
  transition: color 0.3s;
}
.brand-link:hover .brand-text {
  color: #fff;
}

/* 3. حاوية القوائم والتمرير */
.sidebar-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

/* تخصيص شريط التمرير (Webkit) */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #343a40;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #6c757d;
  border-radius: 3px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

/* 4. الروابط والعناصر */
.nav-sidebar {
  width: 100%;
}

.nav-link {
  color: #c2c7d0;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

/* تأثير الهوفر */
.nav-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

/* الرابط النشط */
.nav-link.active {
  background-color: #007bff; /* لون أزرق مميز */
  color: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.nav-icon {
  width: 25px; /* تثبيت عرض الأيقونة */
  text-align: center;
  margin-left: 10px; /* مسافة بين الأيقونة والنص في RTL */
  font-size: 1.1rem;
}

.nav-text {
  font-size: 0.95rem;
}

/* 5. أيقونة السهم */
.right-icon {
  font-size: 0.8rem;
  transition: transform 0.3s ease;
}
.rotate-down {
  transform: rotate(-90deg); /* تدوير السهم عند الفتح */
}

/* 6. القائمة الفرعية */
.nav-treeview {
  background-color: rgba(0, 0, 0, 0.2); /* خلفية أغمق قليلاً */
  padding: 0;
  list-style: none;
  margin: 0;
}

.sub-link {
  padding-right: 30px; /* إزاحة لليمين للتمييز */
  font-size: 0.9rem;
}

.sub-icon {
  font-size: 0.8rem; /* أيقونة أصغر للقوائم الفرعية */
  margin-left: 12px;
}

/* الرابط النشط داخل القائمة الفرعية */
.active-sub {
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: #fff !important;
  font-weight: bold;
  border-right: 3px solid #007bff;
}

/* 7. حركة الانزلاق (Transitions) */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
  opacity: 1;
}
.slide-fade-enter, .slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
</style>